/**
 * State
 */
export const state = {
    breadcrumbs: [],
    loading: false
}

/**
 * Getters
 */
export const getters = {
    breadcrumbs: state => {
      const arr = [
        {
          text: "Dashboard",
          disabled: false,
          link: true,
          to: {name: 'app.index'}
        }
      ]
      return arr.concat(state.breadcrumbs)
    },
    loading: state => state.loading
}

/**
 * Actions
 */
export const actions = {
    updateBreadcrumbs(context, breadcrumbs) {
      context.commit('SET_BREADCRUMBS', breadcrumbs)
    },
    startLoading(context) {
      context.commit('SET_LOADING', true)
    },
    stopLoading(context) {
      context.commit('SET_LOADING', false)
    }
}

/**
 * Mutations
 */
export const mutations = {
    SET_BREADCRUMBS(state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs
    },
    SET_LOADING(state, value) {
      state.loading = value
    }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}